import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component } from '@angular/core';
import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';
import { Router } from '@angular/router';

import { initializeApp } from 'firebase/app';
import { getDatabase, ref, onValue, runTransaction, get } from 'firebase/database';
import { AngularFireDatabase, AngularFireObject } from '@angular/fire/compat/database';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-our-portfolio',
  standalone: true,
  imports: [MatTabsModule, CommonModule],
  templateUrl: './our-portfolio.component.html',
  styleUrl: './our-portfolio.component.css',
})
export class OurPortfolioComponent {
  visitorCount: any = 0;
  visitorCountRef: AngularFireObject<any>;
  visitorCount$: Observable<any>;
  filteredWebCards: any[] = [];
  filteredSSMCards: any[] = [];
  filteredMobileCards: any[] = [];
    webCard = [];
  ssmCards = [];
  mobilecards = [];
  constructor(private router: Router, private cdr: ChangeDetectorRef,private db: AngularFireDatabase) {
  }

  ngOnInit() {
    const app = initializeApp(environment.firebaseConfig);

    this.db.object('/').valueChanges().subscribe((data:any) => {
      this.webCard = data.webCard;
      this.ssmCards = data.ssmCards;
      this.mobilecards = data.mobilecards;
      this.applyScrollLogicToTab();
    });
   }


  getUrl(card: any) {
    return { 'background-image': ` url('${card.image}') ` };
  }

  gotoDetail(detail: any) {
    // let name = detail.tittle.toLowerCase( ).split(" ")[0]
    // this.router.navigateByUrl('/ourproducts/'+name)
  }
  selectedTabIndex: number = 0;
  onTabChange(event: MatTabChangeEvent): void {
    this.selectedTabIndex = event.index;
    console.log('Selected Tab Index: ', this.selectedTabIndex);

    // Apply logic when the second tab is selected (index 1)
    if (this.selectedTabIndex === 1) {
      this.applyScrollLogicToTab();
    }
  }
  applyScrollLogicToTab() {
    this.cdr.detectChanges();
    const cards = document.querySelectorAll('.product_card');
    console.log(cards);

    cards.forEach((card) => {
      card.addEventListener('mouseenter', async () => {
        const imageUrl = this.getComputedBackgroundImage(card);
        const imageHeight = await this.getImageHeight(imageUrl);
        const cardHeight = card.clientHeight;

        const scrollDistance = Math.max(imageHeight - cardHeight, 0);
        const scrollPercent = (scrollDistance / imageHeight) * 100;

        const durationPer100px = 500; // 100px = 1s
        const duration = Math.max(1, scrollDistance / durationPer100px);

        const element = card as HTMLElement;
        element.style.transition = `background-position ${duration}s linear`;
        element.style.backgroundPosition = `center bottom`;
      });

      card.addEventListener('mouseleave', async () => {
        const imageUrl = this.getComputedBackgroundImage(card);
        const imageHeight = await this.getImageHeight(imageUrl);
        const cardHeight = card.clientHeight;

        const scrollDistance = Math.max(imageHeight - cardHeight, 0);
        const durationPer100px = 800;
        const duration = scrollDistance / durationPer100px;

        const element = card as HTMLElement;
        element.style.transition = `background-position ${duration}s linear`;
        element.style.backgroundPosition = 'center top';
      });
    });
  }
  ngAfterViewInit() {
    this.applyScrollLogicToTab();
  }

  getComputedBackgroundImage(el: Element): string {
    const bg = window.getComputedStyle(el).backgroundImage;
    return bg.replace(/^url\(["']?/, '').replace(/["']?\)$/, '');
  }

  getImageHeight(src: string): Promise<number> {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => resolve(img.height);
      img.src = src;
    });
  }
}
